// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@revvsales/components";

class DownloadBtn extends Component {
  state = {};

  render() {
    if (!this.props.isFormMode) {
      return (
        <Button
          className="revv-btn-esign"
          // onClick={() => this.props.togglePopUp("signerDetails", true)}
          onClick={() => {}}
          id={"signerDetails".replace(/ +/g, "-").toLowerCase()}
          data-test="downloadbtn-btn">
          <FontAwesomeIcon
            icon={["far", "signature"]}
            className="documentrecipientlist-role-icon"
          />
          &nbsp; Download
        </Button>
      );
    }
    return null;
  }
}

DownloadBtn.defaultProps = {};

DownloadBtn.propTypes = {};

const mapStateToProps = state => {
  const {
    document: { showForm: isFormMode },
  } = state.DocumentStore;

  return {
    isFormMode,
  };
};

export default connect(mapStateToProps)(DownloadBtn);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Buttons/downloadBtn/index.js